var map = {
	"./Accomplishment.png": 1379,
	"./Calendar-VGL-icon.png": 822,
	"./CollapseFilled.png": 678,
	"./GlobalGivingCausesThumb.png": 1099,
	"./Mistake.png": 1380,
	"./TablePlaceholder.png": 588,
	"./appointments.png": 1381,
	"./calendar.png": 1382,
	"./class-duration-icon.png": 1383,
	"./clients.png": 1384,
	"./dashboard.png": 71,
	"./delete.png": 1385,
	"./event-calendar.png": 1109,
	"./excel-icon.png": 1386,
	"./personal.png": 1387,
	"./reports.png": 1388,
	"./sales.png": 1389,
	"./vector-cover-image.png": 1390,
	"./vectorglobal.png": 1391,
	"./vectorgloballogo.png": 1392,
	"./vg-logo.png": 1101,
	"./vgl-blank-image.png": 1393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1108;